import { AuthService } from './service/auth.service';
import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  show: any;
  constructor(private router: Router, private auth: AuthService) {
    // this.show = this.auth.checkuser(false);
    console.log(this.show);
  }
}





// WEBPACK FOOTER //
// ./src/app/app.component.ts